import React, { useEffect } from 'react';
import { useAuth0 } from "@/lib/auth0";
import OverlayBouncyLoader from "@/presentation/components/loader/overlay-bouncy-loader";
import { getURLSearchParamsAsObject } from "@/lib/misc/utils";
const LoginWithRedirect = () => {
    const { loginWithRedirect } = useAuth0();
    useEffect(() => {
        const redirect = Object.assign({ appState: {
                returnTo: window.location.pathname + window.location.search
            } }, (window.location.pathname === '/') && { authorizationParams: getURLSearchParamsAsObject(window.location.search) });
        loginWithRedirect(redirect);
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(OverlayBouncyLoader, null));
};
export default LoginWithRedirect;
